import React from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { CardContainer, CardContainerBody, CardContainerZone, Field, FieldOrientation, Text, TextFontSize } from '@philips-internal/oswald-ui-components';
import { LayoutAlign, LayoutFlexDirection, LayoutJustify, TextAlignment } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import ScoresIndexesSuepCardContainerAPI from './scores-and-indexes-suep-cardcontainer-api';
import './scores-and-indexes-suep-cardcontainer.css';
var riskValues;
(function (riskValues) {
    riskValues["NORMAL"] = "NORMAL";
    riskValues["ALERT"] = "ALERT";
    riskValues["RISK"] = "RISK";
})(riskValues || (riskValues = {}));
const awesomeProps = {
    api: ScoresIndexesSuepCardContainerAPI,
    type: ComponentType.DATA_DISPLAY,
};
function ScoresIndexesSuepCardContainer(props) {
    function renderBadgeColorClassName(informationRisk) {
        const color = informationRisk !== riskValues.NORMAL ? 'yellow' : 'white';
        return `scores-indexes-field-value-badge scores-indexes-field-value-badge-${color}`;
    }
    function renderValue(scoresIndexes) {
        return (React.createElement(CardContainerZone, { alignItems: LayoutAlign.END, flexDirection: LayoutFlexDirection.COLUMN, justifyContent: LayoutJustify.END, size: 25, uuid: generateUUID() },
            React.createElement(Text, { alignment: TextAlignment.CENTER, className: renderBadgeColorClassName(scoresIndexes.informationRisk) }, String(scoresIndexes.informationValue))));
    }
    function renderInformations(scoresIndexes) {
        const formattedDate = scoresIndexes.informationDate ? ModelService.format('date', scoresIndexes.informationDate, { type: 'timestamp' }) : '--';
        return (React.createElement(CardContainerZone, { alignItems: LayoutAlign.START, flexDirection: LayoutFlexDirection.COLUMN, justifyContent: LayoutJustify.START, size: 75, uuid: generateUUID() },
            React.createElement(Field, { entry: '', orientation: FieldOrientation.HORIZONTAL, uuid: generateUUID(), width: 12 },
                React.createElement(Text, { bold: true, ellipsis: true }, scoresIndexes.informationDescription)),
            React.createElement(Field, { entry: '', orientation: FieldOrientation.HORIZONTAL, uuid: generateUUID(), width: 12 },
                React.createElement(Text, { ellipsis: true, size: TextFontSize.SMALL }, scoresIndexes.resultDescription)),
            React.createElement(Field, { entry: '', orientation: FieldOrientation.HORIZONTAL, uuid: generateUUID(), width: 12 },
                React.createElement(Text, { ellipsis: true, size: TextFontSize.SMALL }, formattedDate))));
    }
    function renderBody(scoresIndexes) {
        return (React.createElement(CardContainerBody, null,
            React.createElement(CardContainerZone, { alignItems: LayoutAlign.CENTER, flexDirection: LayoutFlexDirection.ROW, justifyContent: LayoutJustify.START, size: 100, uuid: generateUUID() },
                renderInformations(scoresIndexes),
                renderValue(scoresIndexes))));
    }
    function renderCardContainer() {
        const scoresIndexes = props;
        const legends = [
            {
                color: 'safety-yellow',
                label: MessageService.translate('tws.risk-interval'),
                value: MessageService.translate('tws.risk-interval')
            }
        ];
        return (React.createElement(CardContainer, { className: 'scores-indexes-cardcontainer', key: scoresIndexes.sequenceNumber, superscription: legends, uuid: generateUUID(), width: 3 }, renderBody(scoresIndexes)));
    }
    return renderCardContainer();
}
AwesomeComponent(awesomeProps)(ScoresIndexesSuepCardContainer);
export default ScoresIndexesSuepCardContainer;
//# sourceMappingURL=scores-and-indexes-suep-cardcontainer.js.map